import React, { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { useLang } from "@/i18n";

const SRC = "/audio/ambiance-nkul.mp3";
const KEY = "ab_music_off";

export const AmbientMusic = () => {
  const { tr } = useLang();
  const audioRef = useRef(null);
  const startedRef = useRef(false);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.volume = 0.28;
    const off = localStorage.getItem(KEY) === "1";

    const start = (e) => {
      if (startedRef.current || localStorage.getItem(KEY) === "1") return;
      if (e?.target?.closest?.('[data-testid="ambient-music-toggle"]')) return;
      startedRef.current = true;
      audio.play().then(() => setPlaying(true)).catch(() => {});
      remove();
    };
    const remove = () => {
      document.removeEventListener("pointerdown", start);
      document.removeEventListener("keydown", start);
    };
    if (!off) {
      document.addEventListener("pointerdown", start);
      document.addEventListener("keydown", start);
    }
    return remove;
  }, []);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      startedRef.current = true;
      audio.play().then(() => setPlaying(true)).catch(() => {});
      localStorage.setItem(KEY, "0");
    } else {
      audio.pause();
      setPlaying(false);
      localStorage.setItem(KEY, "1");
    }
  };

  return (
    <>
      <audio ref={audioRef} src={SRC} loop preload="auto" data-testid="ambient-audio" />
      <button
        onClick={toggle}
        data-testid="ambient-music-toggle"
        aria-label={playing ? "Couper le tam-tam" : "Écouter le tam-tam nkul"}
        title={tr({ fr: "Ambiance — tam-tam de rassemblement ewondo (nkul), cliquez pour couper", en: "Ambient — Ewondo gathering drum (nkul), click to mute" })}
        className="fixed bottom-6 left-6 z-40 flex items-center gap-2 rounded-full border border-ab-gold/30 bg-ab-black/70 backdrop-blur-md px-4 py-2.5 text-ab-gold hover:border-ab-gold/70 hover:bg-ab-black/90 transition-all shadow-lg shadow-black/40"
      >
        {playing ? (
          <span className="flex items-end gap-[3px] h-4 w-4 justify-center" aria-hidden="true" data-testid="ambient-music-bars">
            <span className="w-[3px] h-full bg-ab-gold rounded-full origin-bottom animate-[eq_0.9s_ease-in-out_infinite]" style={{ animationDelay: "0s" }} />
            <span className="w-[3px] h-full bg-ab-gold rounded-full origin-bottom animate-[eq_0.9s_ease-in-out_infinite]" style={{ animationDelay: "0.25s" }} />
            <span className="w-[3px] h-full bg-ab-gold rounded-full origin-bottom animate-[eq_0.9s_ease-in-out_infinite]" style={{ animationDelay: "0.5s" }} />
          </span>
        ) : (
          <VolumeX size={16} />
        )}
        <span className="text-xs tracking-widest uppercase">
          {playing ? <Volume2 size={14} className="inline" /> : "Nkul"}
        </span>
      </button>
    </>
  );
};

export default AmbientMusic;
